import React, { FC, useEffect, useState } from 'react';
import { FieldErrors, UseFormReturn } from 'react-hook-form';
import {
  RelaySwitchScheduleEventDeviceConfig,
  ScheduledEventRelaySwitchState,
} from '@thingslog/repositories';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Chip,
} from '@mui/material';
import { ScheduledEventForm } from '../models/ScheduledEventDto';
import { useTranslation } from 'react-i18next';

export const RelaySwitchEvent: FC<RelaySwitchEventProps> = ({ form }: RelaySwitchEventProps) => {
  const [selectedState, setSelectedState] = useState<ScheduledEventRelaySwitchState>('ON');
  const [requiredStatesList, setRequiredStatesList] = useState<ScheduledEventRelaySwitchState[]>(
    []
  );

  const { t } = useTranslation();

  const {
    watch,
    setValue,
    formState: { errors: formErrors },
  } = form;

  const requiredStates = watch('event.requiredStates');
  const errors = formErrors.event as FieldErrors<RelaySwitchScheduleEventDeviceConfig>;

  useEffect(() => {
    setRequiredStatesList(requiredStates || []);
  }, [requiredStates]);

  const addRequiredState = (): void => {
    const updatedStates = [...(requiredStates || []), selectedState];
    setValue('event.requiredStates', updatedStates, { shouldValidate: true });
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-col md:flex-row gap-2">
        <FormControl fullWidth size="small">
          <InputLabel id="required-state-label">
            {t('scheduled_task_event_form_required_state')}
          </InputLabel>
          <Select
            labelId="required-state-label"
            value={selectedState}
            onChange={(e: SelectChangeEvent<'ON' | 'OFF'>): void => {
              setSelectedState(e.target.value as ScheduledEventRelaySwitchState);
            }}
            label={t('scheduled_task_event_form_required_state')}
          >
            <MenuItem value="ON">{t('on')}</MenuItem>
            <MenuItem value="OFF">{t('off')}</MenuItem>
          </Select>
        </FormControl>
        <Button variant="contained" onClick={addRequiredState}>
          {t('text_add')}
        </Button>
      </div>
      <div className="flex gap-1 flex-wrap pt-2">
        {requiredStatesList.map((state: ScheduledEventRelaySwitchState, index: number) => (
          <Chip key={index} size="small" label={state} />
        ))}
      </div>
    </div>
  );
};

interface RelaySwitchEventProps {
  form: UseFormReturn<ScheduledEventForm, unknown, undefined>;
}
